// extracted by mini-css-extract-plugin
export var closeButton = "_mr-1";
export var closeX = "_mr-3";
export var container = "_mr-0";
export var image = "_mr-2";